import React, { useState, useEffect, useRef } from "react";
import styles from "./CountryFirstSection.module.css";
import passport from "../../assets/images/passport.svg";
import photograph from "../../assets/images/photograph.svg";
import Select, { components } from "react-select";
import { AiFillCaretDown } from "react-icons/ai";
import Radio from "@material-ui/core/Radio";
import DatePicker from "react-datepicker";
import { Link, useHistory } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { countryApi } from "../../config/countryApi";
import { connect } from "react-redux";
import changeDetails from "../../store/Actions/DetailsAction";

import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCheckAll } from "react-icons/bs";
import { BiError } from "react-icons/bi";

import { countryVisaApi } from "../../config/countryVisaApi";




const options3 = [
  { value: "7", label: "7 Days" },
  { value: "14", label: "14 Days" },
  { value: "30", label: "30 Days" },
  { value: "45", label: "45 Days" },
];

function CountryFirstSecion(props) {
  const [service, setService] = useState("");
  const [adults, setAdults] = useState(0);
  const [childrens, setChildrens] = useState(0);
  const [infants, setInfants] = useState(0);
  const [visaTypes, setVisaTypes] = useState(props.visaTypes);
  const [normalFees, setNormalFees] = useState(0);
  const [expressFees, setExpressFees] = useState(0);
  const [embassyFees, setEmbassyFees] = useState(0);
  const [total, setTotal] = useState(0);

  const history = useHistory();

  const [selectedCountry, setSelectedCountry] = useState(props.countryName);
  const [selectedCountryId, setSelectedCountryId] = useState(props.countryId);
  const [selectedVisaType, setSelectedVisaType] = useState(props.selectedType);
  const [selectedVisaId, setSelectedVisaId] = useState(null);
  const [selectedStayDuration, setSelectedStayDuration] = useState(0);
  const [persons, setPersons] = useState(0);
  const [personsDetails, setPersonsDetails] = useState({adults,childrens,infants});
  const [travelDate, setTravelDate] = useState("");
  const [returnDate, setReturnDate] = useState("");


  const [countryValue,setCountryValue] = useState([{id: props.countryId, value:props.countryName, label:<span dangerouslySetInnerHTML={{ __html: `<b>${props.countryCode}</b> &nbsp; &nbsp; &nbsp; ${props.countryName}` }} />}])
  const [selectedType,setSelectedType] = useState(props.selectedType)

  const [fees, setFees] = useState(0);

  const [countryData, setCountryData] = useState([]);
  const [currentCountry, setCurrentCountry] = useState(null);
  const [options2, setOptions2] = useState(props.options2);

  useEffect(()=>{
    const handleVisaType = async (e) => {
      if (e !== null) {
        const country = await countryApi(selectedCountry);
        setSelectedVisaType(e.value);
        setSelectedVisaId(e.id)
        if (country.data) {
          opt3.current.select.clearValue();
          setTravelDate("");
          setReturnDate("");
          const cont = await country.data.data;
          cont.visa_packages.map((value) => {
            if (value.name === e.value) {
              setNormalFees(value.normal_service_fee);
              setExpressFees(value.express_service_fee);
              setEmbassyFees(value.embassy_fee);
            }
          });
        } else if (country.error) {
          setNormalFees(0);
          setExpressFees(0);
          opt3.current.select.clearValue();
          setTravelDate("");
          setReturnDate("");
        }
      }
    };
    handleVisaType(props.selectedType)
  },[])



  const opt1 = useRef();
  const opt2 = useRef();
  const opt3 = useRef();
  const opt4 = useRef();
  const opt5 = useRef();


  const date = new Date();

  const TravelCustomInput = ({ value, onClick }) => (
    <button className={styles.btnDate} onClick={onClick}>
      {value !== "" ? (
        <span style={{ display: "flex", justifyContent: "space-between" }}>
          {value} <AiFillCaretDown size={20} color="#7FA2B6" />
        </span>
      ) : (
        <span
          style={{
            color: "#7FA2B6",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          Travel Date <AiFillCaretDown size={20} />
        </span>
      )}
    </button>
  );

  const ReturnCustomInput = ({ value, onClick }) => (
    <button className={styles.btnDate} onClick={onClick}>
      {value !== "" ? (
        <span style={{ display: "flex", justifyContent: "space-between" }}>
          {value} <AiFillCaretDown size={20} color="#7FA2B6" />
        </span>
      ) : (
        <span
          style={{
            color: "#7FA2B6",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          Return Date <AiFillCaretDown size={20} />
        </span>
      )}
    </button>
  );

  const options1 = props.options1;
  const handleService = (e, fee) => {
    if (fee !== 0) {
      setService(e);
      setFees(fee);
      setAdults(0)
      setChildrens(0)
      setInfants(0)
      setTotal(0)
    } 
    else {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{ marginRight: "10px" }} />
          Please Select Visa Type First!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    };
  };

  const handleAdultsInc = () => {
    if (fees > 0) {
      setAdults(adults + 1);
      setPersons(persons + 1);
      setPersonsDetails({adults:adults+1,childrens:childrens,infants:infants})
      setTotal(total + (fees + embassyFees));
      
    } else {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{ marginRight: "10px" }} />
          Please Select Service Type First!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    };
  };
  const handleChildrensInc = () => {
    if (fees > 0) {
      setChildrens(childrens + 1);
      setPersons(persons + 1);
      setPersonsDetails({adults:adults,childrens:childrens+1,infants:infants})
      setTotal(total + (fees + embassyFees));
    } else {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{ marginRight: "10px" }} />
          Please Select Service Type First!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    };
  };
  const handleInfantsInc = () => {
    if (fees > 0) {
      setInfants(infants + 1);
      setPersons(persons + 1);
      setPersonsDetails({adults:adults,childrens:childrens,infants:infants+1})
      setTotal(total + (fees + embassyFees));
    } else {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{ marginRight: "10px" }} />
          Please Select Service Type First!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    };
  };
  const handleAdultsDec = () => {
    if (adults > 0) {
      setAdults(adults - 1);
      setPersons(persons - 1);
      setPersonsDetails({adults:adults-1,childrens:childrens,infants:infants})
      setTotal(total - (fees + embassyFees));
    }
  };
  const handleChildrensDec = () => {
    if (childrens > 0) {
      setChildrens(childrens - 1);
      setPersons(persons - 1);
      setPersonsDetails({adults:adults,childrens:childrens-1,infants:infants})
      setTotal(total - (fees + embassyFees));
    }
  };
  const handleInfantsDec = () => {
    if (infants > 0) {
      setInfants(infants - 1);
      setPersons(persons - 1);
      setPersonsDetails({adults:adults,childrens:childrens,infants:infants-1})
      setTotal(total - (fees + embassyFees));
    }
  };

  const handleDestination = async (e) => {

    history.push(`/countries/${e.value}`)
    window.location.reload()

    // setOptions2(
    //   [{ label: "Loading...", isDisabled: true }],
    // );
    // const country = await countryApi(e.value);

    // if (country.data) {
    //   setSelectedCountry(e.value);
    //   setOptions2([]);
    //   opt2.current.select.clearValue();
    //   opt3.current.select.clearValue();
    //   setTravelDate("");
    //   setReturnDate("");
    //   const cont = await country.data.data;
    //   setSelectedCountryId(cont._id)
    //   if (cont.visa_packages.length !== 0) {
    //     cont.visa_packages.map((value) => {
    //       setOptions2((options2) => [
    //         ...options2,
    //         { value: value.name, label: value.name, id: value._id },
    //       ]);
    //     });
    //   } else {
    //     setOptions2([]);
    //     opt2.current.select.clearValue();
    //     opt3.current.select.clearValue();
    //     setTravelDate("");
    //     setReturnDate("");
    //   }
    // } else if (country.error) {
    //   setOptions2([]);
    //   opt2.current.select.clearValue();
    //   opt3.current.select.clearValue();
    //   setTravelDate("");
    //   setReturnDate("");
    // }
  };

  const handleVisaType = async (e) => {
    if (e !== null) {
      const country = await countryApi(selectedCountry);
      setSelectedVisaType(e.value);
      setSelectedVisaId(e.id)
      if (country.data) {
        opt3.current.select.clearValue();
        setTravelDate("");
        setReturnDate("");
        const cont = await country.data.data;
        cont.visa_packages.map((value) => {
          if (value.name === e.value) {
            setNormalFees(value.normal_service_fee);
            setExpressFees(value.express_service_fee);
            setEmbassyFees(value.embassy_fee);
          }
        });
      } else if (country.error) {
        setNormalFees(0);
        setExpressFees(0);
        opt3.current.select.clearValue();
        setTravelDate("");
        setReturnDate("");
      }
    }
  };

  const handleStayDuration = (e) => {
    if (e !== null) {
      setSelectedStayDuration(e.value);
    }
  };
  const apply = () => {
    if (
      selectedStayDuration !== null &&
      selectedVisaType !== null &&
      selectedCountryId !== null &&
      selectedVisaId !== null &&
      selectedStayDuration !== 0 &&
      travelDate !== "" &&
      returnDate !== "" &&
      service !== "" && 
      persons !== 0
    ) {
      props.ChangeDetails({
        country: selectedCountry,
        country_id: selectedCountryId,
        visa_type: selectedVisaType,
        visa_id: selectedVisaId,
        stay_duration: selectedStayDuration,
        travel_date: travelDate,
        return_date: returnDate,
        service: service,
        persons: persons,
        persons_details: personsDetails,
        embassy_fees: embassyFees*persons,
        service_fees: fees*persons,
        total: total,
      });
      history.push(`/countries/${selectedCountry}/payment`);
    }
    
    else {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{ marginRight: "10px" }} />
          All Fields Are Required!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    };
  };

  const style1 = {
    control: (base) => ({
      ...base,
      border: "0 !important",
      boxShadow: "0 !important",
      fontSize: "16px",
      fontFamily: "Montserra",
      fontWeight: 400,
      lineHeight: "20px",
      backgroundColor: "#DEF3FF",
      cursor: "pointer",
      height: "60px",
      "&:hover": {
        border: "0 !important",
      },
    }),
    menu: (base) => ({
      ...base,
      marginTop: 30,
      fontSize: 16,
      maxWidth: 341,
    }),
    dropdownIndicator: (defaultStyles) => ({
      ...defaultStyles,
      color: "#7FA2B6",
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      transform: state.selectProps.menuIsOpen && "rotate(180deg)",
      color: "#7FA2B6",
      "&:hover": {
        color: "#7FA2B6",
      },
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled ? "#ffffff" : isFocused ? "#E7E7E7" : null,
        color: "#20313B",
        cursor: isDisabled ? "not-allowed" : "default",
      };
    },
  };

  const style2 = {
    control: (base) => ({
      ...base,
      boxShadow: "0 !important",
      fontSize: "16px",
      fontFamily: "Montserra",
      fontWeight: 400,
      lineHeight: "20px",
      cursor: "pointer",
    }),
    menu: (base) => ({
      ...base,
      marginTop: 2,
      fontSize: 16,
      maxWidth: 341,
    }),
    dropdownIndicator: (defaultStyles) => ({
      ...defaultStyles,
      color: "#7FA2B6",
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      transform: state.selectProps.menuIsOpen && "rotate(180deg)",
      color: "#7FA2B6",
      "&:hover": {
        color: "#7FA2B6",
      },
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled ? "#ffffff" : isFocused ? "#E7E7E7" : null,
        cursor: isDisabled ? "not-allowed" : "default",
        color: "#164550",
        cursor: isDisabled ? "not-allowed" : "default",
        fontSize: "18px",
        fontFamily: "Roboto",
      };
    },
  };

  const DropdownIndicator = (
    props: ElementConfig<typeof components.DropdownIndicator>
  ) => {
    return (
      <components.DropdownIndicator {...props}>
        <AiFillCaretDown size={20} />
      </components.DropdownIndicator>
    );
  };

  return (
    <div>
      <div className={styles.main}>
        <div className={styles.first}>
          <h1 className={styles.firstTitle}>
            {props.countryName} Visa Application
          </h1>
          <p className={styles.firstDes}>
            Visapro helps you apply, book and manage all your visa applications
            in one place.
            <br />
            With a full functional dashbaord, you can monitor and track all your
            ongoing visa applications
          </p>
          <h1 className={styles.firstSecondTitle}>Available visa types</h1>
          <hr className={styles.firstLine} />
          <div className={styles.firstAllBoxes}>
            {visaTypes.length !== 0 ? (
              visaTypes.map((value, index) => (
                <div className={styles.firstBox} key={index}>
                  <h1 className={styles.firstBoxTitle}>{value.name}</h1>
                  <p className={styles.firstboxDes}>₦ {(value.normal_service_fee + value.embassy_fee).toLocaleString()} / Applicant</p>
                </div>
              ))
            ) : (
              <h1 className={styles.firstTitle}>
                No Visa Found In {props.countryName}
              </h1>
            )}
          </div>

          <h1 className={styles.firstSecondTitle}>
            Visa application requirements
          </h1>
          <hr className={styles.firstLine} />
          <div className={styles.firstRequirement}>
            <img src={passport} alt="Passport" />
            <div className={styles.firstRequirementBox}>
              <h1 className={styles.requirementHeading}>Passport Data Page</h1>
              <p className={styles.requirementDes}>
                <span className={styles.mark}></span>
                <span className={styles.req}>
                  Upload colored passport copy.
                </span>
              </p>
              <p className={styles.requirementDes}>
                <span className={styles.mark}></span>
                <span className={styles.req}>
                  Passport should be valid 6 months from the date of entry.
                </span>
              </p>
            </div>
          </div>
          <div className={styles.firstRequirement}>
            <img src={photograph} alt="Photograph" />
            <div className={styles.firstRequirementBox}>
              <h1 className={styles.requirementHeading}>Passport Photograph</h1>
              <p className={styles.requirementDes}>
                <span className={styles.mark}></span>
                <span className={styles.req}>
                  Upload colored passport copy.
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className={styles.second}>
          <div className={styles.secondIn}>
            <h1 className={styles.secondHeading}>Get started here</h1>
            <div className={styles.selection}>
              <div className={styles.select}>
                <Select
                  styles={style1}
                  className={styles.inners}
                  isSearchable={false}
                  options={options1}
                  ref={opt1}
                  value={countryValue}
                  placeholder={"Destination"}
                  onChange={(e) => {setCountryValue([e]); handleDestination(e)}}
                  components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator,
                  }}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      neutral50: "#7FA2B6",
                    },
                  })}
                />
              </div>
              <div className={styles.select}>
                <Select
                  styles={style1}
                  ref={opt2}
                  className={styles.inners}
                  isSearchable={false}
                  options={options2}
                  placeholder={"Visa type"}
                  value={selectedType}
                  onChange={(e) => {setSelectedType([e]); handleVisaType(e)}}
                  components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator,
                  }}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      neutral50: "#7FA2B6",
                    },
                  })}
                />
              </div>
              <div className={styles.select}>
                <Select
                  styles={style1}
                  ref={opt3}
                  className={styles.inners}
                  isSearchable={false}
                  options={options3}
                  placeholder={"Select visa stay duration"}
                  onChange={(e) => {
                    handleStayDuration(e);
                  }}
                  components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator,
                  }}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      neutral50: "#7FA2B6",
                    },
                  })}
                />
              </div>
              <div className={styles.selectSmall}>
                <div className={styles.select1}>
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    selected={travelDate}
                    onChange={(date) => {
                      setTravelDate(date);
                      setReturnDate("");
                    }}
                    customInput={<TravelCustomInput />}
                    minDate={new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)}
                    // maxDate={new Date(Date.now() + (selectedStayDuration+5)* 24 * 60 * 60 * 1000)}
                    allowSameDay={false}
                    ref={opt4}
                  />
                </div>

                <div className={styles.select1}>
                  <DatePicker
                    selected={returnDate}
                    onChange={(date) => setReturnDate(date)}
                    customInput={<ReturnCustomInput />}
                    minDate={travelDate}
                    // maxDate={new Date(Date.now() + selectedStayDuration * 24 * 60 * 60 * 1000)}
                    dateFormat="dd/MM/yyyy"
                    ref={opt5}
                  />
                </div>
              </div>
            </div>
            <div className={styles.details}>
              <h1 className={styles.detailsHeading}>
                30 Days Stay Single Entry
              </h1>
              <p className={styles.detailsDes}>
                The {selectedCountry} Immigration Mandates every passenger has to give a copy
                of International Health Insurance that covers the treatment of
                COVID/ Quarantine during the period of stay in UAE while
                applying visa, Without Submitting Insurance copy, visa will not
                be released.
              </p>
              <h1 className={styles.detailsHeading}>Validity:</h1>
              <p className={styles.detailsDes}>
                You have to enter within{" "}
                <span className={styles.color}>59</span> days from your date of
                visa approval.
              </p>
              <h1 className={styles.detailsHeading}>Processing time:</h1>
              <p className={styles.detailsDes}>
                The visa processing takes{" "}
                <span className={styles.color}>5-8</span> working days.
              </p>
              <div
                className={styles.detailsBack}
                style={
                  service === "normal" ? { backgroundColor: "#def3ff" } : null
                }
                onClick={() => {
                  handleService("normal", normalFees);
                }}
              >
                <div className={styles.in}>
                  <Radio
                    onChange={() => {
                      handleService("normal", normalFees);
                    }}
                    checked={service === "normal"}
                    value="normal"
                    color="default"
                    name="service"
                  />
                  <div>
                    <h1 className={styles.detailsHeading}>Normal Service</h1>
                    <p className={styles.detailsDes}>5-8 working days</p>
                  </div>
                </div>

                <div>
                  <h1 className={styles.detailsHeading}>₦ {normalFees.toLocaleString()}</h1>
                  <p className={styles.detailsDes}>per applicant</p>
                </div>
              </div>
              <div
                className={styles.detailsBack}
                style={
                  service === "express" ? { backgroundColor: "#def3ff" } : null
                }
                onClick={() => {
                  handleService("express", expressFees);
                }}
              >
                <div className={styles.in}>
                  <Radio
                    onChange={() => {
                      handleService("express", expressFees);
                    }}
                    checked={service === "express"}
                    value="express"
                    color="default"
                    name="service"
                  />
                  <div>
                    <h1 className={styles.detailsHeading}>Express Service</h1>
                    <p className={styles.detailsDes}>2-3 working days</p>
                  </div>
                </div>

                <div>
                  <h1 className={styles.detailsHeading}>₦ {expressFees.toLocaleString()}</h1>
                  <p className={styles.detailsDes}>per applicant</p>
                </div>
              </div>
              <div className={styles.detailsLast}>
                <h1 className={styles.detailsLastHead}>
                  Number of persons travelling
                </h1>
                <div className={styles.last}>
                  <div className={styles.lastBox}>
                    <div style={{ width: "90px" }}>
                      <h1 className={styles.lastHead}>
                        Adults<p className={styles.lastDess}>12+ yrs</p>{" "}
                      </h1>
                    </div>
                    <div className={styles.lastbtns}>
                      <button
                        className={styles.btn1}
                        onClick={() => {
                          handleAdultsDec();
                        }}
                      >
                        -
                      </button>
                      <p className={styles.lastpera}>{adults}</p>
                      <button
                        className={styles.btn2}
                        onClick={() => {
                          handleAdultsInc();
                        }}
                      >
                        +
                      </button>
                    </div>
                  </div>
                  <div className={styles.lastBox}>
                    <div style={{ width: "90px" }}>
                      <h1 className={styles.lastHead}>
                        Children<p className={styles.lastDess}>2-11 yrs</p>{" "}
                      </h1>
                    </div>
                    <div className={styles.lastbtns}>
                      <button
                        className={styles.btn1}
                        onClick={() => {
                          handleChildrensDec()
                        }}
                      >
                        -
                      </button>
                      <p className={styles.lastpera}>{childrens}</p>
                      <button
                        className={styles.btn2}
                        onClick={() => {
                          handleChildrensInc()
                        }}
                      >
                        +
                      </button>
                    </div>
                  </div>
                  <div className={styles.lastBox}>
                    <div style={{ width: "90px" }}>
                      <h1 className={styles.lastHead}>
                        Infants<p className={styles.lastDess}>under 2 yrs</p>{" "}
                      </h1>
                    </div>
                    <div className={styles.lastbtns}>
                      <button
                        className={styles.btn1}
                        onClick={() => {
                          handleInfantsDec()
                        }}
                      >
                        -
                      </button>
                      <p className={styles.lastpera}>{infants}</p>
                      <button
                        className={styles.btn2}
                        onClick={() => {
                          handleInfantsInc()
                        }}
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.detailsLast2}>
                <div>
                  <h1 className={styles.detailsLastHead}>Embassy Visa Fee</h1>
                  <p className={styles.detailsDes}>(Fees paid to embassy)</p>
                </div>
                <div>
                  <h1 className={styles.detailsHeading}>₦ {embassyFees.toLocaleString()}</h1>
                  <p className={styles.detailsDes}>per applicant</p>
                </div>
              </div>
              <div className={styles.andCont}>
                <h1 className={styles.total}>Total</h1>
                <h1 className={styles.amount}>₦ {total.toLocaleString()}</h1>
              </div>
              <button className={styles.apply} onClick={() => apply()}>
                Apply
              </button>
            </div>
            <p className={styles.lastDes}>
              *Approval of visa is subject to the decision by the embassy
              Visapro shall not be liable for rejection of visa. Visa processing
              can be delayed in case additional documents are required. See{" "}
              <span className={styles.color}>Terms &amp; Conditions</span>
            </p>
          </div>
        </div>
      </div>
      <ToastContainer
        transition={Slide}
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        className={styles.toasst}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  details: state.Details.details,
  selectedType: state.SelectedType.selectedType,
});

const mapDispatchToProp = (dispatch) => ({
  ChangeDetails: (details) => dispatch(changeDetails(details)),
});

export default connect(mapStateToProps, mapDispatchToProp)(CountryFirstSecion);
